import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'আমাদের পছন্দ',
  bestPriceBadge: 'সেরা দাম',
  regulatedNotice: {
    prescriptionOnly: 'শুধু প্রেসক্রিপশনে',
    professionalUse: 'পেশাদার ব্যবহারের জন্য',
    fromVeterinarian: 'আপনার পশুচিকিৎসকের কাছে পাওয়া যায়',
    fromPharmacist: 'ফার্মাসিস্টের কাছে পাওয়া যায়',
    noOnlinePurchase: 'অনলাইনে বিক্রি হয় না',
    professionalSupply: 'পেশাদার সরবরাহকারীদের মাধ্যমে বিক্রি হয়',
    whyNoLink: 'আমরা এই পণ্যটির পর্যালোচনা করি, কিন্তু এর কোনো লিংক দিই না।',
  },
};
